// @generated

import { decodeHex } from "../common/hex.js"

export default decodeHex(
"\
0061736d0100000001230560027f7f0060067f7f7f7f7f7f0060047f7f7f7e00\
60047f7f7f7f0060037f7f7f0002130107626c616b653262066d656d6f727902\
000103060500010203040607017f004180030b07260408667265655f6d656d03\
0005726573657400000675706461746500030666696e69736800040ad0040522\
00200041800141c000fc0a0000200020002903004280808408852001ad853703\
000ba20101067e20002903002106200129030021072002290300210820032903\
002109200420052d00c0016a290300210a200420052d00c1016a290300210b20\
0620077c200a7c2106200920068542208a2109200820097c2108200720088542\
188a2107200620077c200b7c2106200920068542108a2109200820097c210820\
0720088542018921072000200637030020012007370300200220083703002003\
20093703000bd40201017f4100200041c000fc0a000041c00041800141c000fc\
0a000041e00041e0002903002002ad8537030041f00041f00029030020038537\
030003404100412041c00041e0002001200410014108412841c80041e8002001\
200441026a10014110413041d00041f0002001200441046a10014118413841d8\
0041f8002001200441066a10014100412841d00041f8002001200441086a1001\
4108413041d80041e00020012004410a6a10014110413841c00041e800200120\
04410c6a10014118412041c80041f00020012004410e6a1001200441106a2204\
41c001490d000b20002000fd0004004100fd000400fd5141c000fd000400fd51\
fd0b040020002000fd0004104110fd000400fd5141d000fd000400fd51fd0b04\
1020002000fd0004204120fd000400fd5141e000fd000400fd51fd0b04202000\
2000fd0004304130fd000400fd5141f000fd000400fd51fd0b04300b24000340\
20034180016a21032000200120034200100220014180016a22012002490d000b\
0b0c00200020012002427f10020b0b880201004180010b800208c9bcf367e609\
6a3ba7ca8485ae67bb2bf894fe72f36e3cf1361d5f3af54fa5d182e6ad7f520e\
511f6c3e2b8c68059b6bbd41fbabd9831f79217e1319cde05b00081018202830\
3840485058606870787050204048786830086000105838281858406000281078\
6850701830380848203848180868605870103028502000784048002838102050\
7870085860304018681060305000584018206838287870084860280878706820\
5000383018481040586858387060081848280078204030105030787048581800\
4060106838082050285010402038300828785848701860680000081018202830\
38404850586068707870502040487868300860001058382818\
",
)
